import { InputWithIcon } from '@/components/ui/vehicle/input-with-icon';
import { toast } from '@/hooks/use-toast';
import { pdkAxios } from '@/lib/pdk-axios';
import { cn } from '@/lib/utils';
import { vehicleFromIndexerStore } from '@/models/stores/vehicle-listings';
import type { VehicleFromIndexer } from '@/models/types';
import { useMutation } from '@tanstack/react-query';
import { Route } from 'lucide-react';

export type EPARangeInputProps = {
  id: string;
  value: VehicleFromIndexer['epa_range'];
  className?: string;
};

export function EPARangeInput({ id, value, className }: EPARangeInputProps) {
  const updateEPARangeMutation = useMutation({
    onMutate: async ({ epaRange }) => {
      vehicleFromIndexerStore.updateEPARange({ id, epaRange });
    },
    mutationFn: async ({
      epaRange,
    }: {
      epaRange: VehicleFromIndexer['epa_range'];
    }) => {
      return await pdkAxios.post(`/inventory/vehicles/${id}/epa_range`, {
        epa_range: epaRange,
      });
    },
    onError: (error) => {
      toast({
        title: 'Error updating EPA range',
        description: error.message,
        variant: 'destructive',
      });
    },
  });

  const handleEPARangeChange = (newEPARange: string) => {
    // Handle empty string or invalid input
    if (newEPARange === '' || isNaN(parseInt(newEPARange))) {
      updateEPARangeMutation.mutate({ epaRange: 0 });
    } else {
      updateEPARangeMutation.mutate({ epaRange: parseInt(newEPARange) });
    }
  };

  return (
    <div>
      <InputWithIcon
        icon={<Route className="h-4 w-4" />}
        value={value?.toString() || ''}
        placeholder="EPA range"
        onChange={handleEPARangeChange}
        className={cn('pl-0', className)}
        inputClassName="w-7"
        suffix="miles"
      />
    </div>
  );
}
